import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { AdminPausedBanner } from "components/profileSettings/AdminPausedBanner";

export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
        px: 3,
      }}
    >
      <AdminPausedBanner />
      <SearchOffIcon
        sx={{
          fontSize: 120,
          color: "text.secondary",
          mb: 3,
        }}
      />

      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: "4rem", sm: "6rem" },
          fontWeight: 700,
          color: "text.primary",
          mb: 2,
          lineHeight: 1,
        }}
      >
        404
      </Typography>

      <Typography
        variant="h4"
        sx={{
          fontWeight: 500,
          color: "text.primary",
          mb: 4,
        }}
      >
        {t("pageNotFound")}
      </Typography>

      <Button
        onClick={() => {
          window.history.back();
        }}
        variant="contained"
        size="large"
        sx={{
          px: 4,
          borderRadius: 2,
          textTransform: "none",
          fontSize: "1.1rem",
          fontWeight: 600,
          textDecoration: "none",
        }}
      >
        {t("back")}
      </Button>
    </Box>
  );
};
